<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import type { HTMLAttributes } from 'vue'
import { cva } from 'class-variance-authority'

export const loadingAnimationVariants = cva('inline-block shrink-0', {
  variants: {
    size: {
      xs: 'size-7.5',
      sm: 'size-12.5',
      md: 'size-25',
      lg: 'size-50',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type LoadingAnimationVariants = VariantProps<typeof loadingAnimationVariants>

export interface LoadingAnimationProps {
  size?: LoadingAnimationVariants['size']
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'
import { Spinner } from '#ui-kit/ui/spinner'
import { useLottie } from '../useLottie'

const props = withDefaults(defineProps<LoadingAnimationProps>(), {
  size: 'md',
})

const { player, animationData } = useLottie(() => import('./assets/loading.json'))
</script>

<template>
  <span
    data-slot="loading-animation"
    role="status"
    aria-label="Loading"
    :class="cn(loadingAnimationVariants({ size: props.size }), props.class)"
  >
    <component :is="player" v-if="player && animationData" :animation-data="animationData" />
    <span v-else class="flex size-full items-center justify-center">
      <Spinner :size="props.size" aria-hidden="true" />
    </span>
  </span>
</template>
